import { LoaderPage } from '@component/loader/loader.page';

import { useLoginCallback } from './use-login-callback.hook';

export const LoginCallbackPage = () => {
  useLoginCallback();

  return <LoaderPage />;
};
